import {
    CogIcon,
    ViewGridIcon,
} from '../Icon'
import {
    Dropdown,
    DropdownButton,
    DropdownContent,
} from '../Dropdown'
import {
    styledSidebar,
    styledSidebarContent,
    styledSidebarHeader,
} from './styles'
import Activity from '../Activity'
import Button from '../Button'
import Logout from '../Logout'
import React from 'react'
import SidebarAudiences from '../SidebarAudiences'
import SidebarChannels from '../SidebarChannels'
import SidebarDialogues from '../SidebarDialogues'
import SidebarQueues from '../SidebarQueues'
import SidebarRealms from './SidebarRealms'
import SidebarUser from './SidebarUser'
import {SidebarViewProps} from './types'
import {styled} from 'stitches/config'
import {styledItem} from 'components/Dropdown/styles'
import {useTranslation} from 'react-i18next'

const StyledSidebar = styled('div', styledSidebar)
const StyledSidebarHeader = styled('div', styledSidebarHeader)
const StyledSidebarContent = styled('div', styledSidebarContent)

const StyledItem = styled('div', styledItem)

const SidebarActivityView = ({hasActivity}: {hasActivity: boolean}) => (
    <>
        {hasActivity ? <><Activity /> <hr /> </> : null}
        {}
    </>
)
const SidebarHomeView = ({
    changeRoute, ...other
}: Pick<SidebarViewProps, 'changeRoute'>) => {
    const {t} = useTranslation()
    return (
        <StyledItem {...other}>
            <Button
                color='text'
                iconLeft={ViewGridIcon}
                onPress={(): void => {
                    changeRoute('Home')
                }}
                text={t('Home')}
                type='button'
            />
        </StyledItem>
    )
}
const SidebarSettingsView = ({
    changeRoute, ...other
}: Pick<SidebarViewProps, 'changeRoute'>) => {
    const {t} = useTranslation()
    return (
        <StyledItem {...other}>
            <Button
                color='text'
                iconLeft={CogIcon}
                onPress={(): void => { changeRoute('Settings') }}
                text={t('Settings and profile')}
                type='button'
            />
        </StyledItem>
    )
}
const SidebarView: React.FC<SidebarViewProps> = (props): React.ReactElement => {
    const {
        changeRoute,
        realm_id: realmId,
        activityCount,
        hasActivity,
        hasHighlight,
        sidebar_classic_audience_grouping,
    } = props

    return (
        <StyledSidebar>
            <StyledSidebarHeader>
                <Dropdown>
                    <DropdownButton caret={true} customClass='sidebar' hasActivity={hasActivity} hasHighlight={hasHighlight}>
                        <SidebarUser activityCount={activityCount} hasActivity={hasActivity} />
                    </DropdownButton>
                    <DropdownContent customClass='full-width' direction='left'>
                        <SidebarActivityView hasActivity={hasActivity} />
                        <SidebarHomeView changeRoute={changeRoute} />
                        <SidebarSettingsView changeRoute={changeRoute} />
                        <hr />
                        <StyledItem>
                            <Logout />
                        </StyledItem>
                    </DropdownContent>
                </Dropdown>
                <SidebarRealms />
            </StyledSidebarHeader>
            <StyledSidebarContent data-id='sidebar-content'>
                <SidebarQueues realm_id={realmId!} />
                <SidebarChannels realm_id={realmId!} />
                {sidebar_classic_audience_grouping ? <SidebarAudiences realm_id={realmId!} /> : null}
                <SidebarDialogues />
            </StyledSidebarContent>
        </StyledSidebar>
    )
}

const isEqual = (prevProps: SidebarViewProps, nextProps: SidebarViewProps): boolean => prevProps?.realm_id === nextProps?.realm_id &&
        prevProps?.activityCount === nextProps?.activityCount &&
        prevProps?.highlightCount === nextProps?.highlightCount &&
        prevProps?.hasActivity === nextProps?.hasActivity &&
        prevProps?.hasHighlight === nextProps?.hasHighlight &&
        prevProps?.sidebar_classic_audience_grouping === nextProps?.sidebar_classic_audience_grouping


export default React.memo(SidebarView, isEqual)
